import { render, staticRenderFns } from "./arquivarOrcamento.vue?vue&type=template&id=30ee83b5"
import script from "./arquivarOrcamento.ts?vue&type=script&lang=js&external"
export * from "./arquivarOrcamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ee83b5')) {
      api.createRecord('30ee83b5', component.options)
    } else {
      api.reload('30ee83b5', component.options)
    }
    module.hot.accept("./arquivarOrcamento.vue?vue&type=template&id=30ee83b5", function () {
      api.rerender('30ee83b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/arquivarOrcamento.vue"
export default component.exports